import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../../internal/index.js';

// eslint-disable-next-line react/display-name
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const IconComponent = /*#__PURE__*/React.forwardRef((props, ref) => {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsxs("g", {
      fill: "currentColor",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M18.56 12.06a1.5 1.5 0 1 1-2.12-2.121 1.5 1.5 0 0 1 2.12 2.122Zm-13.12 0a1.5 1.5 0 1 0 2.12-2.12 1.5 1.5 0 0 0-2.12 2.122Zm7.62 0a1.5 1.5 0 1 0-2.121-2.12 1.5 1.5 0 0 0 2.122 2.12Z"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M1.834 16.582.301 23.5l9.002-2.266c.867.174 1.77.266 2.697.266 6.627 0 12-4.701 12-10.5S18.627.5 12 .5 0 5.201 0 11c0 2.051.672 3.965 1.834 5.582Zm1.12 4.187 1.027-4.628-.523-.726C2.522 14.112 2 12.602 2 11c0-4.452 4.218-8.5 10-8.5S22 6.548 22 11s-4.218 8.5-10 8.5c-.795 0-1.566-.079-2.303-.227l-.444-.09-6.299 1.586Z"
      })]
    })
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export const IconActionMessageLine24 = createIcon(IconComponent);